export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-xl font-bold mb-4 text-yellow-400">Yaad Boyz Detailing</h3>
            <p className="text-gray-400 mb-4">
              Professional auto detailing services. We bring out the best in every vehicle.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-gray-400 hover:text-yellow-400 transition-colors cursor-pointer">
                  Services
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-yellow-400 transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
              <li>
                <a href="tel:+18763632297" className="text-gray-400 hover:text-yellow-400 transition-colors cursor-pointer">
                  Book Now
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contact</h4>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <a href="tel:+18692165666" className="hover:text-yellow-400 transition-colors cursor-pointer">
                  +1 (869) 216-5666
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <a href="mailto:yaadboyzdetailing@gmail.com" className="hover:text-yellow-400 transition-colors cursor-pointer">
                  yaadboyzdetailing@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>United States</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Yaad Boyz Detailing. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-yellow-400 transition-colors text-sm cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}